import { render, staticRenderFns } from "./SwitchControl.vue?vue&type=template&id=73232e2d&scoped=true&"
import script from "./SwitchControl.vue?vue&type=script&lang=js&"
export * from "./SwitchControl.vue?vue&type=script&lang=js&"
import style0 from "./SwitchControl.vue?vue&type=style&index=0&id=73232e2d&prod&scoped=true&lang=css&"
import style1 from "./SwitchControl.vue?vue&type=style&index=1&id=73232e2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73232e2d",
  null
  
)

export default component.exports